import { API_AUTH_BASE, API_PATH_AUTH_LOGIN, API_AUTH_APP_CODE } from '@/features/auth/constants';

export interface LoginData {
  username: string;
  password: string;
  domainName?: 'pickandgo' | 'sensei' | string;
}

/**
 * login
 * @param data
 */
export const login = (data: LoginData) => {
  let loginBody = { ...data, appCode: API_AUTH_APP_CODE };
  return fetch(API_AUTH_BASE + API_PATH_AUTH_LOGIN, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(loginBody),
  }).then(async (res) => {
    const response = await res.json();
    if (!res.ok) {
      throw response;
    }
    return response;
  });
};
